import { render } from "./ComponentNotificationItem.vue?vue&type=template&id=106aeef4&scoped=true"
import script from "./ComponentNotificationItem.vue?vue&type=script&lang=js"
export * from "./ComponentNotificationItem.vue?vue&type=script&lang=js"

import "./ComponentNotificationItem.vue?vue&type=style&index=0&id=106aeef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106aeef4"]])

export default __exports__